import { applicantsSlice } from './applicants.slice.ts';

export const { updateApplicantDataSet, updateSelectedApplicant, resetApplicant } =
  applicantsSlice.actions;
